import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, EmailIcon, WhatsAppIcon } from './Icons';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <img 
              src="/logo.png" 
              alt="Happy Yatra Travels Logo" 
              className="h-12 md:h-16 w-auto object-contain mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Your trusted travel partner for unforgettable journeys and experiences.
            </p>
          </div>

          <div>
            <h4 className="text-primary-blue text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  Home
                </a>
              </li>
              <li>
                <Link to="/packages" className="text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  Packages
                </Link>
              </li>
              <li>
                <Link to="/b2b" className="text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  B2B Partners
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <a href="/#contact" className="text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-primary-blue text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:+917718838808" className="flex items-center gap-2 text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  <PhoneIcon className="w-4 h-4" />
                  <span>+91 77188 38808</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@happyyatratravels.in" className="flex items-center gap-2 text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm">
                  <EmailIcon className="w-4 h-4" />
                  <span>info@happyyatratravels.in</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/917718838808" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-300 hover:text-primary-orange transition-colors duration-300 text-sm"
                >
                  <WhatsAppIcon className="w-4 h-4" />
                  <span>WhatsApp Us</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-primary-blue text-lg font-semibold mb-4">Follow Us</h4>
            <div className="flex flex-wrap gap-3">
              <a href="https://www.facebook.com/officialhappyyatratravels" className="px-4 py-2 bg-gray-800 rounded-lg hover:bg-primary-orange transition-all duration-300 text-sm">
                Facebook
              </a>
              <a href="https://www.instagram.com/happy.yatratravel" className="px-4 py-2 bg-gray-800 rounded-lg hover:bg-primary-orange transition-all duration-300 text-sm">
                Instagram
              </a>
              <a href="https://www.youtube.com/@HappyYatraTravel" className="px-4 py-2 bg-gray-800 rounded-lg hover:bg-primary-orange transition-all duration-300 text-sm">
                Youtube
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Happy Yatra Travels. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
